import { z } from 'zod';

enum EldPartnerTypeId {
  NoIntegration = 0,
  IntegratedPartner = 1,
  CommonPartnerHubPartner = 2,
}

export const eldPartnerTypeSchema = z.object({
  eldPartnerTypeId: z.nativeEnum(EldPartnerTypeId),
  eldPartnerTypeDescription: z.string().nullable(),
});

export type EldPartnerType = z.infer<typeof eldPartnerTypeSchema>;
